import { useQuery } from '@apollo/client'
import { Flex, Box, Heading, Button, Text } from 'rebass/styled-components'
import { TextAreaNoForm } from '../../../components/TextArea';
import { GET_ENCOUNTER_CONTENT } from '../../../graphql/queries';
import { IGetEncounterAdditionalContentInput, IGetEncounterAdditionalContentOutput } from '../../../graphql/types/queries/appointment';
import PleaseWait from '../../../components/PleaseWait';

interface IViewAdditionalEncounterInfoProps {
  close: () => void
  appointmentId: string
}

export const ViewAdditionalEncounterInfo: React.FC<IViewAdditionalEncounterInfoProps> = ({ appointmentId, close }) => {
  const { data, loading, error, refetch } = useQuery<IGetEncounterAdditionalContentOutput, IGetEncounterAdditionalContentInput>(GET_ENCOUNTER_CONTENT, {
    nextFetchPolicy: 'network-only',
    variables: {
      appointmentId
    }
  })
  // console.log({data})
  return (
    <Box style={{ margin: '0 auto', maxWidth: '90vw', maxHeight: '90vh', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', overflow: 'hidden' }}>
      <Heading mb={4}>Additional Encounter Content3</Heading>
      {/* <Button onClick={() => refetch()}>Refetch</Button> */}

      {!!loading ? (
        <PleaseWait />
      ) : (
        <Flex style={{ gap: '12px', overflowY: 'auto' }} flexDirection={'column'}>
          <Text fontSize='14px' fontWeight={500} mt={3}>ICDs:</Text>
          {data?.healthcoachGetEncounterContent?.icds && data?.healthcoachGetEncounterContent?.icds.length > 0 ? (
            <>
              {data.healthcoachGetEncounterContent.icds.map(x => {
                return (
                  <Text paddingY={'8px'} ml={['12px']} key={x.code} style={{
                    paddingLeft: '12px',
                    borderLeft: '1px solid #344F7A99'
                  }} fontWeight={300} fontSize='12px'>
                    {x.code}: {x.description}
                  </Text>
                )
              })}
            </>
          ) : (
            <Text paddingY={'8px'} ml={['12px']} style={{
              paddingLeft: '12px',
              opacity: 0.75,
              borderLeft: '1px solid #344F7A99'
            }} fontWeight={300} fontSize='12px' >No ICDs reported</Text>
          )}

          <Text fontSize='14px' fontWeight={500} mt={3}>Patient instructions</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.instructions || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>Patient goals</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.goals || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>discussion Notes</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.discussionNotes || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>assessment</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.assessment || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>hpis</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.hpis || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>physical Exam</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
            __html: data?.healthcoachGetEncounterContent?.physicalExam || ''
          }}></Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>encounter reasons</Text>
          {data?.healthcoachGetEncounterContent?.encounterreasons && data?.healthcoachGetEncounterContent?.encounterreasons.encounterreasons && data?.healthcoachGetEncounterContent?.encounterreasons.encounterreasons.length > 0 ? (
            <>
              {data?.healthcoachGetEncounterContent?.encounterreasons.encounterreasons.map(x => {
                return (
                  <Text paddingY={'8px'} ml={['12px']} key={x.encounterreasonid} style={{
                    paddingLeft: '12px',
                    borderLeft: '1px solid #344F7A99'
                  }} fontWeight={300} fontSize='12px' >{x.encounterreasontext}</Text>
                )
              })}
            </>
          ) : (
            <Text paddingY={'8px'} ml={['12px']} style={{
              paddingLeft: '12px',
              opacity: 0.75,
              borderLeft: '1px solid #344F7A99'
            }} fontWeight={300} fontSize='12px' >No encounter reasons reported</Text>
          )}


          <Text fontSize='14px' fontWeight={500} mt={3}>Review of Systems</Text>
          {data?.healthcoachGetEncounterContent?.ros ? (
            <>

              <Text paddingY={'8px'} ml={['12px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px'>
                Summary Text: {data?.healthcoachGetEncounterContent?.ros.summarytext || 'None reported'}<br /><br />
                Well Child Summary Text: {data?.healthcoachGetEncounterContent?.ros.wellchildsummarytext || 'None reported'}
              </Text>
            </>
          ) : (
            <Text paddingY={'8px'} ml={['12px']} style={{
              paddingLeft: '12px',
              opacity: 0.75,
              borderLeft: '1px solid #344F7A99'
            }} fontWeight={300} fontSize='12px' >No ROS reported</Text>
          )}


          <Text fontSize='14px' fontWeight={500} mt={3}>Procedure Documentations</Text>
          {data?.healthcoachGetEncounterContent?.procedures ? (
            <>
              <Text paddingY={'8px'} ml={['12px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' >Outcome</Text>
              {!data?.healthcoachGetEncounterContent?.procedures.outcome?.result && !data?.healthcoachGetEncounterContent?.procedures.outcome?.note ? (
                <Text paddingY={'8px'} ml={['24px']} style={{
                  paddingLeft: '12px',
                  borderLeft: '1px solid #344F7A99',
                  opacity: 0.75
                }} fontWeight={300} fontSize='12px' >None reported</Text>
              ) : (
                <Text paddingY={'8px'} ml={['24px']} style={{
                  paddingLeft: '12px',
                  borderLeft: '1px solid #344F7A99'
                }} fontWeight={300} fontSize='12px' >{data?.healthcoachGetEncounterContent?.procedures.outcome?.result}<br />{data?.healthcoachGetEncounterContent?.procedures.outcome?.note}</Text>
              )}

              <Text paddingY={'8px'} ml={['12px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' >Complications</Text>
              {!data?.healthcoachGetEncounterContent?.procedures.complications || data?.healthcoachGetEncounterContent?.procedures.complications.length < 1 ? (
                <Text paddingY={'8px'} ml={['24px']} style={{
                  paddingLeft: '12px',
                  borderLeft: '1px solid #344F7A99',
                  opacity: 0.75
                }} fontWeight={300} fontSize='12px' >None reported</Text>
              ) : (
                <>
                  {(data?.healthcoachGetEncounterContent?.procedures.complications || []).map(x => {
                    return (
                      <Text paddingY={'8px'} ml={['24px']} key={x.complication} style={{
                        paddingLeft: '12px',
                        borderLeft: '1px solid #344F7A99'
                      }} fontWeight={300} fontSize='12px' dangerouslySetInnerHTML={{
                        __html: x.complication || ''
                      }}></Text>
                    )
                  })}
                </>)}

              <Text paddingY={'8px'} ml={['12px']} style={{
                paddingLeft: '12px',
                borderLeft: '1px solid #344F7A99'
              }} fontWeight={300} fontSize='12px' >procedure documentation text</Text>
              {!data?.healthcoachGetEncounterContent?.procedures.proceduredocumentationtext ? (
                <Text paddingY={'8px'} ml={['24px']} style={{
                  paddingLeft: '12px',
                  borderLeft: '1px solid #344F7A99',
                  opacity: 0.75
                }} fontWeight={300} fontSize='12px' >None reported</Text>
              ) : (
                <Text paddingY={'8px'} ml={['24px']} style={{
                  paddingLeft: '12px',
                  borderLeft: '1px solid #344F7A99'
                }} fontWeight={300} fontSize='12px' >{data?.healthcoachGetEncounterContent?.procedures.proceduredocumentationtext}</Text>
              )}
            </>
          ) : (
            <Text paddingY={'8px'} ml={['12px']} style={{
              paddingLeft: '12px',
              opacity: 0.75,
              borderLeft: '1px solid #344F7A99'
            }} fontWeight={300} fontSize='12px' >No procedure documentation reported</Text>
          )}
        </Flex>
      )}

      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} >Cancel</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>
    </Box>);
}